export enum PENDING_EDITS {
  REJECT_EDIT = 'REJECT_EDIT',
  APPROVE_EDIT = 'APPROVE_EDIT',
  CANCEL_EDIT = 'CANCEL_EDIT',
  REJECT_EDIT_REQUEST = 'REJECT_EDIT_REQUEST',
}
